var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { aelf, sleep } from '@portkey-v1/utils';
import { AElfContract } from './aelfContract.js';
import { getTxResult, handleContractError, handleContractParams, handleFunctionName } from './utils/index.js';
export class AElfCAContract extends AElfContract {
    constructor(options) {
        super(options);
        this.caContractAddress = options.caContractAddress;
        this.caContract = options.caContract;
        this.caHash = options.caHash;
    }
    callSendMethod(functionName, _account, paramsOption, sendOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.caContract)
                return { error: { code: 401, message: 'Contract init error' } };
            try {
                const { onMethod = 'receipt' } = sendOptions || {};
                let _params, _functionName;
                if (this.address !== this.caContractAddress) {
                    _functionName = 'ManagerForwardCall';
                    const methodName = handleFunctionName(functionName);
                    _params = yield handleContractParams({
                        instance: this.aelfInstance,
                        paramsOption: Object.assign({ args: paramsOption, caHash: this.caHash, methodName, contractAddress: this.address }, sendOptions === null || sendOptions === void 0 ? void 0 : sendOptions.appendParams),
                        functionName: _functionName,
                    });
                }
                else {
                    _functionName = handleFunctionName(functionName);
                    _params = yield handleContractParams({
                        instance: this.aelfInstance,
                        paramsOption,
                        functionName: _functionName,
                    });
                }
                const req = yield this.caContract[_functionName](_params);
                const { TransactionId } = req.result || req;
                if (req.error)
                    return { error: handleContractError(undefined, req), transactionId: TransactionId };
                // receipt
                if (onMethod === 'receipt') {
                    yield sleep(1000);
                    try {
                        const txResult = yield getTxResult(this.aelfInstance, TransactionId);
                        return { data: txResult, transactionId: TransactionId };
                    }
                    catch (error) {
                        return { error: handleContractError(error, req), transactionId: TransactionId };
                    }
                }
                // transactionHash
                return { transactionId: TransactionId };
            }
            catch (error) {
                return { error: handleContractError(error) };
            }
        });
    }
    encodedTx(functionName, paramsOption, callOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.aelfContract)
                return { error: { code: 401, message: 'Contract init error' } };
            if (!this.aelfInstance)
                return { error: { code: 401, message: 'instance init error' } };
            try {
                let _params, _functionName;
                if (this.address !== this.caContractAddress) {
                    _functionName = 'ManagerForwardCall';
                    const methodName = handleFunctionName(functionName);
                    _params = yield handleContractParams({
                        instance: this.aelfInstance,
                        paramsOption: Object.assign({ args: paramsOption, caHash: this.caHash, methodName, contractAddress: this.address }, callOptions === null || callOptions === void 0 ? void 0 : callOptions.appendParams),
                        functionName: _functionName,
                    });
                }
                else {
                    _functionName = handleFunctionName(functionName);
                    _params = yield handleContractParams({
                        instance: this.aelfInstance,
                        paramsOption,
                        functionName: _functionName,
                    });
                }
                const data = yield aelf.encodedTx({
                    instance: this.aelfInstance,
                    contract: this.caContract,
                    paramsOption: _params,
                    functionName: _functionName,
                });
                return { data };
            }
            catch (error) {
                return handleContractError(error);
            }
        });
    }
}
